import React from "react";
import Swiper from "react-id-swiper";
import sliderData from "../../data/hero-sliders/hero-slider-ten.json";
import HeroSliderTenSingle from "../../components/hero-slider/HeroSliderTenSingle.js";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
const HeroSliderTen = () => {
  const curr_location = useSelector((state) => state.locationsData.location)
  const branch_id = curr_location.id;
  const params = {
    effect: "fade",
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    watchSlidesVisibility: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    ),
  };
  return (
    <div className="slider-area mb-55">
      <div className="slider-active nav-style-1">
        <Swiper {...params}>
          {sliderData &&
            sliderData
              .filter((data) => {
                return data.branch_id == branch_id || data.branch_id == 0;
              })
              .map((single, key) => {
                return (
                  <HeroSliderTenSingle
                    data={single}
                    key={key}
                    sliderClass="swiper-slide"
                  />
                );
              })}
        </Swiper>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
  cLocation: state.locationsData.location
  }
}

export default connect(mapStateToProps)(HeroSliderTen);
